var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchMergeCandidates } from "../api/titleMergeService";
import { MERGE_CANDIDATE_LIMIT } from "../types/titleMerge";
import { useDebouncedValue } from "./useDebouncedValue";
var SEARCH_DEBOUNCE_MS = 300;
var MIN_SEARCH_CHARS = 3;
export var useTitleMergeCandidates = function (search, type, setIds, enabled) {
    var kyInstance = useOkapiKy();
    var trimmed = search.trim();
    var debounced = useDebouncedValue(trimmed, SEARCH_DEBOUNCE_MS);
    var isDebouncePending = trimmed !== debounced;
    var isSearchable = debounced.length >= MIN_SEARCH_CHARS;
    var _a = useQuery(["title-merge-candidates", debounced, type, __spreadArray([], setIds, true).sort()], function () { return fetchMergeCandidates(kyInstance, debounced, type, setIds); }, { enabled: enabled && isSearchable, staleTime: 30000 }), _b = _a.data, candidates = _b === void 0 ? [] : _b, isLoading = _a.isLoading;
    return {
        candidates: candidates,
        isSearchable: isSearchable,
        isTruncated: candidates.length >= MERGE_CANDIDATE_LIMIT,
        candidateLimit: MERGE_CANDIDATE_LIMIT,
        minSearchChars: MIN_SEARCH_CHARS,
        isCandidatesLoading: enabled && isSearchable && (isLoading || isDebouncePending),
    };
};
